import { Component } from 'react';
import PageMeta from './PageMeta';
import { Link } from 'react-router-dom';
import { DataRPC } from '../../rpc-client/DataRPC';
import { s3 } from '../../config/constants';
import SakuraSep from './SakuraSep';
import SakuraOrbit from './SakuraOrbit';

const rpc = new DataRPC();

/* ── Date helpers ─────────────────────────────────────────── */
const MONTH_ABBR = [
    'THG 1','THG 2','THG 3','THG 4','THG 5','THG 6',
    'THG 7','THG 8','THG 9','THG 10','THG 11','THG 12',
];

const parseDate = (dateStr) => {
    if (!dateStr) return { day: '--', monthNum: 0, month: '---', year: '----' };
    const d = new Date(dateStr + 'T00:00:00');
    return {
        day:      String(d.getDate()).padStart(2, '0'),
        monthNum: d.getMonth() + 1,
        month:    MONTH_ABBR[d.getMonth()],
        year:     String(d.getFullYear()),
    };
};

const statusLabel = (startDate, endDate) => {
    const now   = new Date(); now.setHours(0, 0, 0, 0);
    const start = new Date(startDate + 'T00:00:00');
    const end   = endDate ? new Date(endDate + 'T00:00:00') : start;
    if (now < start)  return 'SẮP DIỄN RA';
    if (now <= end)   return 'ĐANG DIỄN RA';
    return 'ĐÃ KẾT THÚC';
};

const mapFestival = (f) => {
    const start   = parseDate(f.start_date);
    const end     = parseDate(f.end_date);
    const sameDay = !f.end_date || f.start_date === f.end_date;
    return {
        id:       f.id,
        slug:     f.slug,
        newsLink: f.news_link || '',
        img:      f.banner_url || f.avatar_url || '',
        status:   statusLabel(f.start_date, f.end_date),
        category: '',
        name:     f.name,
        day:      start.day,
        monthNum: start.monthNum,
        month:    start.month,
        year:     start.year,
        time:     sameDay ? '' : ('– ' + end.day + '/' + end.monthNum + '/' + end.year),
        location: f.location || '',
        summary:  f.short_description || '',
    };
};

/* ── Calendar widget ──────────────────────────────────────── */
const MONTH_NAMES = [
    'Tháng 1','Tháng 2','Tháng 3','Tháng 4','Tháng 5','Tháng 6',
    'Tháng 7','Tháng 8','Tháng 9','Tháng 10','Tháng 11','Tháng 12',
];
const DAY_NAMES = ['CN','T2','T3','T4','T5','T6','T7'];

class FestivalCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            year:    props.initYear  != null ? props.initYear  : new Date().getFullYear(),
            month:   props.initMonth != null ? props.initMonth : new Date().getMonth(),
            hovered: null,
        };
    }

    go = (dir) => {
        this.setState(({ year, month }) => {
            let m = month + dir, y = year;
            if (m < 0)  { m = 11; y--; }
            if (m > 11) { m = 0;  y++; }
            return { year: y, month: m, hovered: null };
        });
    };

    render() {
        const { year, month, hovered } = this.state;
        const { festivals } = this.props;

        const festMap = {};
        festivals.forEach(f => {
            festMap[`${f.year}-${f.monthNum}-${parseInt(f.day, 10)}`] = f;
        });

        const today       = new Date();
        const firstDow    = new Date(year, month, 1).getDay();
        const daysInMonth = new Date(year, month + 1, 0).getDate();

        const cells = Array(firstDow).fill(null);
        for (let d = 1; d <= daysInMonth; d++) cells.push(d);

        return (
            <div className="cal-widget">
                <div className="cal-header">
                    <button className="cal-nav" onClick={() => this.go(-1)} aria-label="Tháng trước">‹</button>
                    <span className="cal-month-label">{MONTH_NAMES[month]} {year}</span>
                    <button className="cal-nav" onClick={() => this.go(1)}  aria-label="Tháng sau">›</button>
                </div>

                <div className="cal-body">
                    <div className="cal-grid">
                        {DAY_NAMES.map(d => (
                            <div key={d} className="cal-day-name">{d}</div>
                        ))}
                        {cells.map((day, i) => {
                            if (!day) return <div key={`e${i}`} className="cal-cell cal-empty" />;
                            const key  = `${year}-${month + 1}-${day}`;
                            const fest = festMap[key];
                            const isToday = today.getFullYear() === year &&
                                            today.getMonth()    === month &&
                                            today.getDate()     === day;
                            return (
                                <div
                                    key={day}
                                    className={['cal-cell', fest ? 'cal-festival' : '', isToday ? 'cal-today' : ''].filter(Boolean).join(' ')}
                                    onMouseEnter={fest ? () => this.setState({ hovered: fest }) : undefined}
                                    onMouseLeave={fest ? () => this.setState({ hovered: null }) : undefined}
                                >
                                    {day}
                                    {fest && <span className="cal-dot" />}
                                </div>
                            );
                        })}
                    </div>

                    <div className={`cal-hint${hovered ? ' cal-hint-active' : ''}`}>
                        {hovered ? (
                            <>
                                <span className="cal-hint-icon">桜</span>
                                <span className="cal-hint-text">{hovered.name}</span>
                            </>
                        ) : (
                            <span className="cal-hint-idle"> Lễ hội </span>
                        )}
                    </div>
                </div>

                <div className="cal-legend">
                    {festivals.map((f, i) => (
                        <div key={i} className="cal-legend-row">
                            <span className={`cal-legend-date${f.status === 'ĐÃ KẾT THÚC' ? ' cal-legend-date--ended' : ''}`}>{f.day}/{f.monthNum}/{f.year}</span>
                            <span className="cal-legend-name">{f.name}</span>
                        </div>
                    ))}
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />
            </div>
        );
    }
}

/* ── Icons ────────────────────────────────────────────────── */
const CalendarIcon = () => (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="fmeta-icon">
        <rect x="2" y="4" width="16" height="14" rx="2" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M2 8h16" stroke="currentColor" strokeWidth="1.5"/>
        <path d="M6 2v4M14 2v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
);

const PinIcon = () => (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className="fmeta-icon">
        <path d="M10 2a6 6 0 016 6c0 4-6 10-6 10S4 12 4 8a6 6 0 016-6z" stroke="currentColor" strokeWidth="1.5"/>
        <circle cx="10" cy="8" r="2" stroke="currentColor" strokeWidth="1.5"/>
    </svg>
);

/* ── Page component ───────────────────────────────────────── */
class Festival extends Component {
    state = { festivals: [], allYears: [], filterYear: 'all', loading: true };

    componentDidMount() {
        rpc.fetchRawData('GetFestivals', { page: 1, limit: 200 })
            .then(res => {
                const statusRank = (f) => {
                    const s = statusLabel(f.start_date, f.end_date);
                    return s === 'ĐÃ KẾT THÚC' ? 1 : 0;
                };
                const sorted = (res.data || []).slice().sort((a, b) => {
                    const ra = statusRank(a);
                    const rb = statusRank(b);
                    if (ra !== rb) return ra - rb;
                    const dir = ra === 0 ? 1 : -1;
                    return dir * (new Date(a.start_date) - new Date(b.start_date));
                });
                const mapped = sorted.map(mapFestival);
                const allYears = [...new Set(mapped.map(f => f.year))].sort((a, b) => b - a);
                this.setState({ festivals: mapped, allYears, filterYear: 'all', loading: false });
            })
            .catch(() => this.setState({ loading: false }));
    }

    render() {
        const { festivals, allYears, filterYear, loading } = this.state;

        const visibleFests = filterYear === 'all'
            ? festivals.slice(0, 6)
            : festivals.filter(f => f.year === filterYear);

        const firstUpcoming = visibleFests.find(f => f.status !== 'ĐÃ KẾT THÚC');
        const calYear  = firstUpcoming ? parseInt(firstUpcoming.year, 10)
            : (filterYear !== 'all' ? parseInt(filterYear, 10) : new Date().getFullYear());
        const calMonth = firstUpcoming ? firstUpcoming.monthNum - 1 : new Date().getMonth();

        return (
            <div className="festival-page">
                <PageMeta title="Lễ hội" description="Khám phá các lễ hội Yosakoi tại Việt Nam – thông tin, lịch trình và địa điểm." url="/festival" image="https://vietnamyosakoi.com/images/slider-image-1.jpg" />

                <div className="page-header festival-page-header">
                    <div className="page-header-overlay" />
                    <div className="container page-header-body">
                        <div className="row">
                            <div className="col-12">
                                <div className="entry-meta-date">Việt Nam Yosakoi Festival</div>
                                <h1 className="page-header-title">LỄ HỘI</h1>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="sep-gold-rule" style={{margin: 0}} />

                <div className="festival-list">
                    <div className="container">
                        <div className="festival-layout">

                            <div className="festival-main">
                                <div className="entry-title">
                                    <p>LỊCH SỰ KIỆN</p>
                                    <h2>CÁC SỰ KIỆN &amp; LỄ HỘI TRONG NĂM</h2>
                                </div>

                                {!loading && allYears.length > 0 && (
                                    <div className="gal-filter-bar fest-year-filter">
                                        <div className="gal-filter-select-wrap">
                                            <label className="gal-filter-label" htmlFor="fest-filter-year">Năm tổ chức:</label>
                                            <div className="gal-select-box">
                                                <select
                                                    id="fest-filter-year"
                                                    value={filterYear}
                                                    onChange={e => this.setState({ filterYear: e.target.value })}
                                                >
                                                    <option value="all">Gần đây</option>
                                                    {allYears.map(y => (
                                                        <option key={y} value={y}>{y}</option>
                                                    ))}
                                                </select>
                                                <span className="gal-select-arrow" />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {loading && (
                                    <div className="fsk-wrap">
                                        <SakuraOrbit label="Đang tải thông tin lễ hội" />

                                        {/* ── Skeleton cards (muted backdrop) ── */}
                                        <div className="fsk-list">
                                            {[0, 1, 2].map(i => (
                                                <div key={i} className="fsk-card" style={{ animationDelay: `${i * 0.13}s` }}>
                                                    <div className="fsk-img">
                                                        <div className="fsk-badge-status" />
                                                        <div className="fsk-badge-date">
                                                            <div className="fsk-bd-month" />
                                                            <div className="fsk-bd-day" />
                                                            <div className="fsk-bd-year" />
                                                        </div>
                                                    </div>
                                                    <div className="fsk-body">
                                                        <div className="fsk-cat" />
                                                        <div className="fsk-name" />
                                                        <div className="fsk-name fsk-name--short" />
                                                        <div className="fsk-meta-row"><div className="fsk-meta-icon" /><div className="fsk-meta-text" /></div>
                                                        <div className="fsk-meta-row"><div className="fsk-meta-icon" /><div className="fsk-meta-text fsk-meta-text--short" /></div>
                                                        <div className="fsk-summary" />
                                                        <div className="fsk-summary fsk-summary--short" />
                                                        <div className="fsk-cta" />
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                {!loading && visibleFests.length === 0 && (
                                    <p style={{ color: '#6F8BA4', padding: '40px 0' }}>Chưa có sự kiện nào.</p>
                                )}

                                <div className="festival-cards">
                                    {visibleFests.map((f, i) => (
                                        <Link key={f.id || i} to={f.newsLink ? '/news/' + f.newsLink : '/festival/' + (f.slug || f.id)} className="festival-card">
                                            <div className="festival-img">
                                                <img src={s3(f.img, 'images/next-event-1.jpg')} alt={f.name} />
                                                <span className="festival-status-badge">{f.status}</span>
                                                <div className="festival-date-badge">
                                                    <div className="fdb-month">{f.month}</div>
                                                    <div className="fdb-day">{f.day}</div>
                                                    <div className="fdb-year">{f.year}</div>
                                                </div>
                                            </div>
                                            <div className="festival-body">
                                                {f.category && <span className="festival-category">{f.category}</span>}
                                                <h3 className="festival-name">{f.name}</h3>
                                                <div className="festival-meta">
                                                    <div className="fmeta-row">
                                                        <CalendarIcon />
                                                        <span>{f.day} {f.month} {f.year}{f.time ? ' · ' + f.time : ''}</span>
                                                    </div>
                                                    {f.location && (
                                                        <div className="fmeta-row">
                                                            <PinIcon />
                                                            <span>{f.location}</span>
                                                        </div>
                                                    )}
                                                </div>
                                                {f.summary && <p className="festival-summary">{f.summary}</p>}
                                                <div className="festival-cta">
                                                    Xem Chi Tiết
                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                                                        <polyline points="9 18 15 12 9 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            <aside className="festival-sidebar">
                                <div className="festival-sidebar-sticky">
                                    {loading && (
                                        <div className="fsk-cal">
                                            <div className="fsk-cal-header" />
                                            <div className="fsk-cal-grid">
                                                {Array.from({ length: 35 }).map((_, i) => (
                                                    <div key={i} className="fsk-cal-cell" style={{ animationDelay: `${(i % 7) * 0.04}s` }} />
                                                ))}
                                            </div>
                                            <div className="fsk-cal-legend">
                                                {[0,1].map(i => <div key={i} className="fsk-cal-legend-row" />)}
                                            </div>
                                        </div>
                                    )}
                                    {!loading && (
                                        <FestivalCalendar
                                            key={calYear + '-' + calMonth}
                                            festivals={visibleFests}
                                            initYear={calYear}
                                            initMonth={calMonth}
                                        />
                                    )}
                                </div>
                            </aside>

                        </div>
                    </div>
                </div>

                <SakuraSep />

                <div className="sep-gold-rule" style={{margin: 0}} />

            </div>
            
        );
    }
}

export default Festival;
